import EA from 'helpers/init';

export default EA.Methods.videoControl = ($this) => {
    const btn  = $this.querySelector('.video-control');
    const video  = $this.querySelector('video');

    video.play().catch(() => {
        $this.classList.add('paused');
    });

    btn.addEventListener('click', () => {
        if (video.paused) {
            video.play();
        } else {
            video.pause();
        }
        $this.classList.toggle('paused');
    });
};
